import { clamp } from "lodash-es";

/** A percentage travels to the backend as a fraction string ("0.07"); the UI shows and edits whole percents. */
export const PERCENT = 100;

/**
 * The percent text for a stored fraction: `0.07 * 100` is 7.000000000000001 in floating point, so
 * the product is rounded to two percent decimals, which loses nothing against four-decimal storage.
 */
export const toPercentText = (fraction: string): string =>
  String(Math.round(Number(fraction) * PERCENT * 100) / 100);

/**
 * The fraction string for a percent the user typed, clamped to 0–100 %: the backend caps the
 * fraction at 1 and answers anything above with a raw Pydantic dump (RV2-pap-lifecycle-06).
 *
 * Four decimals, the scale of the `Numeric(5, 4)` column: `1.1 / 100` is 0.011000000000000001 in
 * floating point, which the backend would store as a changed value on a re-save nobody edited.
 */
export const toFraction = (percent: number): string =>
  (clamp(percent, 0, PERCENT) / PERCENT).toFixed(4);
